@if (addButtonVisible) {
    <button
        type="button"
        id="display"
        type="text"
        (click)="showAddFileDialog()"
        hisImage="plus_circ_green"
        class="transparent"
    >
        {{ "cs.sys.filemanagement.newDocument" | hisUi }}
    </button>
}

@if (showDocumentsTable()) {
    <p-table [value]="documents">
        <ng-template pTemplate="header">
            <tr>
                <th>{{ "common.components.inputFile.filename" | hisUi }}</th>
                @if (showCommentColumn()) {
                    <th>
                        {{
                            "common.components.inputFile.resourceComment"
                                | hisUi
                        }}
                    </th>
                }
                <th>
                    {{ "common.components.inputFile.commonCategory" | hisUi }}
                </th>
                <th>{{ "common.components.inputFile.createdAt" | hisUi }}</th>
                <th>
                    {{ "de.his.javang.aktionen" | hisUi }}
                </th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-file let-rowIndex="rowIndex">
            <tr>
                <td>{{ file.name }}</td>
                @if (showCommentColumn()) {
                    <td>{{ file.comment }}</td>
                }
                <td>{{ category(file.documentMetadataCategoryId, false) }}</td>
                <td>{{ file.createdAt | date: ('common.dateTimeFormatShort' | hisUi) }}</td>
                <td>
                    <button
                        type="button"
                        (click)="showEditFileDialog(file)"
                        hisImage="PENCIL"
                        class="icon"
                        [title]="'common.editOf' | hisUi: file.name"
                    ></button>
                    <button
                        type="button"
                        (click)="deleteFile(file)"
                        hisImage="DELETE"
                        class="icon"
                        [title]="'common.deleteOf' | hisUi: file.name"
                    ></button>
                    <his-upload-file-download
                        [value]="file"
                    ></his-upload-file-download>
                </td>
            </tr>
        </ng-template>
    </p-table>
}

<p-dialog
    [header]="'common.components.inputFile.addFile' | hisUi"
    [(visible)]="displayAddFileDialog"
    [responsive]="true"
    [modal]="true"
    [dismissableMask]="false"
    [blockScroll]="true"
    (onHide)="hideAddFileDialog(addFileInput)"
>
    <his-plam #addFilePlam renderLabelAsDiv>
        <his-file-upload
            #content
            #addFileInput
            [configKey]="configKey"
            [(ngModel)]="newFiles"
        >
        </his-file-upload>
    </his-plam>
    <button type="button" (click)="addFile()">
        {{ "common.apply" | hisUi }}
    </button>
</p-dialog>

<p-dialog
    [header]="'common.components.inputFile.addEdit' | hisUi"
    [(visible)]="displayEditFileDialog"
    [responsive]="true"
    [modal]="true"
    [dismissableMask]="false"
    [blockScroll]="true"
>
    @if (showEditCategory()) {
        <his-plam
            [showLabelTop]="true"
            [label]="'common.components.inputFile.commonCategory' | hisUi"
        >
            <p-autoComplete
                #content
                [dropdown]="true"
                [forceSelection]="true"
                optionLabel="defaulttext"
                [(ngModel)]="editCategory"
                [suggestions]="filteredCategories"
                (completeMethod)="filterCategories($event)"
            >
            </p-autoComplete>
        </his-plam>
    }
    @if (showEditComment()) {
        <his-plam
            [showLabelTop]="true"
            [label]="'common.components.inputFile.resourceComment' | hisUi"
        >
            <textarea
                #content
                class="textareaWidth100"
                [(ngModel)]="editComment"
                [disabled]="editCommentDisabled()"
            >
            </textarea>
        </his-plam>
    }
    <button type="button" (click)="updateFile()">
        {{ "common.apply" | hisUi }}
    </button>
</p-dialog>
